/* MRC Cart Page Interactions - robust */
(function () {
  'use strict';
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  function changeLine(payload, qty) {
    // payload kann {line: N} oder {id: keyOrVariantId} sein
    var body = Object.assign({}, payload, { quantity: qty });
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error('change failed ' + r.status + ': ' + t.slice(0, 200)); });
      return r.json();
    });
  }

  function renderSummary(cart) {
    var root = document.querySelector('[data-mrc-cart-root]');
    var threshold = parseInt((root && root.dataset.thresholdCents) || '3000', 10);
    var shippingCents = parseInt((root && root.dataset.shippingCents) || '399', 10);
    var subtotalCents = cart.items_subtotal_price;
    var reached = (threshold > 0 && subtotalCents >= threshold);
    var deltaCents = Math.max(0, threshold - subtotalCents);
    var effectiveShipping = reached ? 0 : shippingCents;
    var grandTotalCents = cart.total_price + effectiveShipping;

    /* Subtotal + Gesamt */
    var sub = document.querySelector('[data-mrc-subtotal]');
    var tot = document.querySelector('[data-mrc-total]');
    if (sub) sub.textContent = money(subtotalCents);
    if (tot) tot.textContent = money(grandTotalCents);

    /* Versand-Row */
    var shipCell = document.querySelector('[data-mrc-shipping-cell]');
    if (shipCell) {
      if (reached) {
        shipCell.innerHTML = '<span class="mrc-cart__summary-free">GRATIS</span>';
      } else {
        shipCell.textContent = money(shippingCents);
      }
    }

    /* Shipbar (Text + isReached + Progress) */
    var shipbar = document.querySelector('[data-mrc-shipbar]');
    if (shipbar) {
      shipbar.classList.toggle('is-reached', reached);
      var textEl = shipbar.querySelector('.mrc-cart__shipbar-text');
      if (textEl) {
        if (reached) {
          textEl.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> <strong>Gratisversand</strong> ist freigeschaltet - innerhalb Deutschlands';
        } else {
          textEl.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Noch <strong>' + money(deltaCents) + '</strong> bis zum Gratisversand';
        }
      }
      var fill = shipbar.querySelector('.mrc-cart__shipbar-fill');
      if (fill && threshold > 0) {
        var pct = Math.min(100, Math.round(subtotalCents / threshold * 100));
        fill.style.width = pct + '%';
      }
    }

    /* Item-Count Label */
    var countEl = document.querySelector('.mrc-cart__count');
    if (countEl) {
      countEl.textContent = cart.item_count === 1 ? '1 Artikel' : cart.item_count + ' Artikel';
    }

    /* Per-Item Line-Price refresh */
    var cards = document.querySelectorAll('[data-mrc-cart-item]');
    cart.items.forEach(function (item, idx) {
      var card = cards[idx];
      if (!card) return;
      card.setAttribute('data-key', item.key);
      // Line-Key aendert sich, wenn ein Rabatt greift -> Input + Remove-Button mitziehen (sonst 400 "keine gueltige ID" beim naechsten Change)
      var keyInp = card.querySelector('[data-mrc-qty-input]');
      if (keyInp) keyInp.setAttribute('data-key', item.key);
      var keyRm = card.querySelector('[data-mrc-cart-remove]');
      if (keyRm) keyRm.setAttribute('data-mrc-cart-remove', item.key);
      var priceEl = card.querySelector('.mrc-cart-item__price-final');
      if (priceEl) priceEl.textContent = money(item.final_line_price);
      var wasEl = card.querySelector('.mrc-cart-item__price-was');
      if (wasEl) {
        if (item.original_line_price && item.original_line_price > item.final_line_price) {
          wasEl.textContent = money(item.original_line_price);
          wasEl.style.display = '';
        } else {
          wasEl.style.display = 'none';
        }
      }
      // Rabatt-Badge ("X Stueck (-Y EUR)") aus den aktuellen Allocations neu bauen (Titel/Stufe aendert sich beim Mengenwechsel)
      var discUl = card.querySelector('.mrc-cart-item__discounts');
      if (discUl) {
        var allocs = item.line_level_discount_allocations || [];
        if (allocs.length) {
          var tagSvg = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
          discUl.innerHTML = allocs.map(function (d) {
            var title = String((d.discount_application && d.discount_application.title) || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; });
            return '<li>' + tagSvg + ' ' + title + ' (-' + money(d.amount) + ')</li>';
          }).join('');
          discUl.style.display = '';
        } else {
          discUl.innerHTML = '';
          discUl.style.display = 'none';
        }
      }
      var input = card.querySelector('[data-mrc-qty-input]');
      if (input && parseInt(input.value, 10) !== item.quantity) {
        input.value = item.quantity;
      }
    });
  }

  function updateAndRender(payload, qty, card, qtyWrap) {
    if (qtyWrap) qtyWrap.classList.add('is-updating');
    if (card) card.classList.add('is-updating');
    return changeLine(payload, qty).then(function (cart) {
      if (qty === 0 && card) {
        card.remove();
        if (!cart.items.length) {
          window.location.reload();
          return;
        }
      }
      renderSummary(cart);
      document.dispatchEvent(new CustomEvent('mrc:cart:updated', { detail: cart }));
    }).catch(function (err) {
      console.error('Cart update failed', err);
    }).finally(function () {
      if (qtyWrap) qtyWrap.classList.remove('is-updating');
      if (card) card.classList.remove('is-updating');
    });
  }

  var debounceTimers = new WeakMap();
  function scheduleChange(input) {
    if (debounceTimers.has(input)) clearTimeout(debounceTimers.get(input));
    debounceTimers.set(input, setTimeout(function () {
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      var card = input.closest('[data-mrc-cart-item]');
      var wrap = input.closest('[data-mrc-qty]');
      // Stabilen Line-Item-Key nutzen (data-line verschiebt sich nach Entfernen -> Bug)
      var payload = { id: input.getAttribute('data-key') };
      updateAndRender(payload, qty, card, wrap);
    }, 320));
  }

  document.addEventListener('click', function (e) {
    var btn;
    btn = e.target.closest('[data-mrc-qty-inc]');
    if (btn) {
      e.preventDefault();
      var inp = btn.parentNode.querySelector('[data-mrc-qty-input]');
      if (inp) { inp.value = (parseInt(inp.value, 10) || 0) + 1; scheduleChange(inp); }
      return;
    }
    btn = e.target.closest('[data-mrc-qty-dec]');
    if (btn) {
      e.preventDefault();
      var inp2 = btn.parentNode.querySelector('[data-mrc-qty-input]');
      if (inp2) {
        var v = parseInt(inp2.value, 10) || 0;
        if (v > 0) { inp2.value = v - 1; scheduleChange(inp2); }
      }
      return;
    }
    btn = e.target.closest('[data-mrc-cart-remove]');
    if (btn) {
      e.preventDefault();
      var card_r = btn.closest('[data-mrc-cart-item]');
      // Stabilen Line-Item-Key nutzen (verhindert haengendes "laesst sich nicht leeren")
      var payload_r = { id: btn.getAttribute('data-mrc-cart-remove') };
      updateAndRender(payload_r, 0, card_r, null);
      return;
    }
    btn = e.target.closest('[data-mrc-discount-apply]');
    if (btn) {
      e.preventDefault();
      var inp3 = document.getElementById('mrc-discount-input');
      var code = (inp3 && inp3.value || '').trim().toUpperCase();
      if (!code) { if (inp3) inp3.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-mrc-qty-input]');
    if (inp) scheduleChange(inp);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.id === 'mrc-discount-input') {
      e.preventDefault();
      var b = document.querySelector('[data-mrc-discount-apply]');
      if (b) b.click();
    }
  });
})();
